import { render } from "./PasswordStrengthIndicator.vue?vue&type=template&id=54dd8e4d"
import script from "./PasswordStrengthIndicator.vue?vue&type=script&lang=js"
export * from "./PasswordStrengthIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__